module.exports = __webpack_public_path__ + "fonts/StdKaiXHYL5EG-Md.svg";